var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('XDialog',{attrs:{"buttons":_vm.buttons,"text":_vm.text,"title":_vm.title,"value":_vm.value,"width":_vm.width,"persistent":_vm.persistent},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"dialog-content",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }